import { SortOrder } from "@nozbe/watermelondb/QueryDescription";
import React from "react";

export interface UseSortByOptions<T extends object> {
  defaultSortBy?: { [key in keyof T]: SortOrder };
}

export type UseSortByResult<T extends object> = {
  sortBy: { [key in keyof T]: SortOrder } | undefined;
  sort: (column: keyof T | undefined) => void;
};

export const useSortBy = <T extends object>(options?: UseSortByOptions<T>) => {
  const [sortBy, setSortBy] = React.useState<
    { [key in keyof T]: SortOrder } | undefined
  >(options?.defaultSortBy);

  const sortByFn = React.useCallback(
    (column: keyof T | undefined) => {
      if (!column) {
        setSortBy(undefined);
        return;
      }
      setSortBy((prev) => {
        if (!prev) {
          return { [column]: "asc" } as any;
        }

        if (prev[column] === "asc") {
          return { [column]: "desc" } as any;
        }

        return undefined;
      });
    },
    [sortBy]
  );

  return {
    sortBy,
    sort: sortByFn,
  };
};
